export const locale = {
  lang: 'zh2',
  data: {
    'TOOLBAR': {
        'PERFIL': '我的简历',
        'INBOX': '收件箱',
        'LOGOUT': '登出',
        'ADMIN': '登录为：',
        'LOGIN':'在登录: ',
        'GOPROFILE':'Profile',
        'CITIES':{
          '0':'',
          '1':'墨西哥城',
          '2':'San salvador',
          '3':'Hong kong',
          '4':'Singapure',
          '5':'Istanbul',
          '6':'Victoria',
          '8':'墨西哥城',
          '11':'São Paulo',
          '14':'墨西哥城',
          '15':'Madrid',
          'IZZI':'墨西哥城',
          'MX':'墨西哥城',
          '19':'墨西哥城',
      },
      'LOGOUT_MODAL': {
        'TEXTO': '您确定要退出吗？',
        'SI': '是的',
        'NO': '不'
      }
    }
  }
};
